<template>
  <ModalProvider
    id="modalSubirValeDevolucion"
    ref="modal"
    size="md"
  >
    <template #title>
      <i class="fas fa-file-upload mr-1"></i> Subir Vale de Devolución
    </template>

    <template #body>
      <!-- Zona de archivo seleccionado -->
      <div v-if="previewUrl" class="d-flex flex-column align-items-center justify-content-between p-3 position-relative"
        style="background-color: #f8f9fa; border-radius: 8px; border: 1px dashed #dee2e6; min-height: 200px;">

        <button type="button" class="btn btn-sm btn-danger position-absolute"
          style="top: -10px; right: -10px; border-radius: 50%; width: 30px; height: 30px; padding: 0; z-index: 10;"
          @click="removeFile" title="Remover archivo">
          <i class="fas fa-times"></i>
        </button>

        <div class="mb-2 text-dark font-weight-bold w-100 text-center" style="font-size: 0.9em;">
          <i class="fas fa-file-pdf mr-1 text-danger"></i> Vale Seleccionado
        </div>

        <div class="d-flex flex-column w-100 align-items-center justify-content-center flex-grow-1 text-danger">
          <i class="fas fa-file-pdf fa-4x mb-2"></i>
        </div>

        <span class="mt-2 text-muted w-100 text-center" style="word-break: break-all; font-size: 0.85em; font-weight: 500;">
          {{ fileName }}
        </span>
      </div>

      <!-- Zona de drop / selección cuando no hay archivo -->
      <div v-else
        class="d-flex flex-column align-items-center justify-content-center p-4"
        style="background-color: #fcfcfc; border-radius: 8px; border: 2px dashed #bbbbbb; cursor: pointer; transition: background-color 0.2s; min-height: 200px;"
        onmouseover="this.style.backgroundColor='#f0f0f0'"
        onmouseout="this.style.backgroundColor='#fcfcfc'"
        @click="triggerInput"
      >
        <i class="fas fa-cloud-upload-alt fa-3x text-muted mb-3"></i>
        <span class="font-weight-bold text-muted text-center">Click para buscar el Vale PDF</span>
        <span class="text-muted text-center" style="font-size: 0.8em;">Solo PDF</span>
      </div>

      <!-- Input oculto -->
      <input type="file" ref="fileInput" class="d-none" accept=".pdf" @change="handleFileUpload" />

      <!-- Indicador si ya tiene archivo guardado -->
      <div v-if="current && current.archivo_url && !previewUrl" class="mt-3 alert alert-info border-0 py-2 d-flex align-items-center justify-content-between">
        <span><i class="fas fa-check-circle mr-1"></i> Ya tiene un vale guardado.</span>
        <a :href="current.archivo_url" target="_blank" class="btn btn-sm btn-outline-info">
          <i class="fas fa-eye mr-1"></i> Ver
        </a>
      </div>
    </template>

    <template #footer="{ hide }">
      <ButtonProvider
        label="Confirmar Subida"
        variant="success"
        class="w-50 py-3 mr-2 font-weight-bold"
        icon="fa-save"
        :disabled="!uploadFile"
        :loading="loading"
        @click="subirVale(hide)"
      />
      <ButtonProvider
        label="Cancelar"
        variant="secondary"
        class="w-50 py-3 ml-2 font-weight-bold"
        icon="fa-times"
        @click="cancelar(hide)"
      />
    </template>
  </ModalProvider>
</template>

<script>
import DevolucionesProveedoresService from "@/services/inventario/DevolucionesProveedoresService";
import Notifications from "@/notifications/notifications";
import { ModalProvider, ButtonProvider } from "@/components/atomic";

export default {
  name: "SubirValeDevolucionModal",
  components: {
    ModalProvider,
    ButtonProvider,
  },
  props: {
    current: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      uploadFile: null,
      previewUrl: null,
      fileName: "",
      loading: false,
    };
  },
  mounted() {
    $("#modalSubirValeDevolucion").on("hide.bs.modal", this.resetForm);
  },
  beforeDestroy() {
    $("#modalSubirValeDevolucion").off("hide.bs.modal", this.resetForm);
  },
  methods: {
    triggerInput() {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.click();
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      event.target.value = "";

      if (!file) {
        this.removeFile();
        return;
      }

      // Validación estricta: solo PDF
      var esPDF = file.type === "application/pdf" || file.name.toLowerCase().indexOf(".pdf") === file.name.toLowerCase().length - 4;
      if (!esPDF) {
        Notifications.alert.error(
          "Archivo no permitido",
          "Solo se permiten archivos PDF. Por favor selecciona un archivo con extensión .pdf"
        );
        this.removeFile();
        return;
      }

      this.uploadFile = file;
      this.fileName = file.name;
      if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
      this.previewUrl = URL.createObjectURL(file);
    },
    removeFile() {
      this.uploadFile = null;
      this.fileName = "";
      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = null;
      }
      if (this.$refs.fileInput) this.$refs.fileInput.value = "";
    },
    resetForm() {
      this.removeFile();
      this.loading = false;
    },
    cancelar(hide) {
      this.resetForm();
      if (typeof hide === "function") hide();
      else $("#modalSubirValeDevolucion").modal("hide");
    },
    subirVale(hide) {
      var self = this;
      if (!this.uploadFile) return;

      this.loading = true;
      DevolucionesProveedoresService.subir_vale_devolucion(this.current.id, this.uploadFile)
        .then(function() {
          Notifications.alert.success(
            "Subir Vale de Devolución",
            "Archivo subido correctamente"
          );
          self.resetForm();
          self.$emit("uploaded");
          if (typeof hide === "function") hide();
          else $("#modalSubirValeDevolucion").modal("hide");
        })
        .catch(function(error) {
          self.loading = false;
          var msg = (error && error.response && error.response.data && error.response.data.detail) || "No se pudo subir el archivo";
          Notifications.alert.error("Subir Vale de Devolución", msg);
        });
    },
  },
};
</script>
